import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=62bf4568&scoped=true&"
import script from "./ResourceDetail.vue?vue&type=script&lang=ts&"
export * from "./ResourceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=62bf4568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf4568",
  null
  
)

export default component.exports